module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/CoupleViewingAlbum-61fb24c782eada9c77884892c5d5cdd7.webp";